import { LayoutComponent } from '../layout/layout.component';
import { authGuard } from '../auth/auth.guard';
import { LoginComponent } from '../login/login.component';
import { BlankLayoutComponent } from '../layout/blank-layout/blank-layout.component';
import { WelcomeComponent } from '../login/welcome/welcome.component';
import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: '',
    canActivate: [authGuard],
    component: LayoutComponent,
    children: [
      { path: '', redirectTo: 'logifleet', pathMatch: 'full' },
      {
        path: 'logifleet',
        loadComponent: () =>
          import('../dashboard/dashboard.component').then(
            m => m.DashboardComponent
          )
      }
    ]
  },

  {
    path: '',
    component: BlankLayoutComponent,
    children: [
      { path: 'login', component: LoginComponent },
      { path: 'welcome', component: WelcomeComponent }
    ]
  },

  // Not found
  { path: '**', redirectTo: 'login' }
];
